/**
 * This file is part of Magestore POS Open Source.
 *
 * Magestore POS Open Source is free software: you can redistribute it
 * and/or modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation, either version 3
 * of the License, or (at your option) any later version.
 *
 * Magestore POS Open Source is distributed in the hope that it will
 * be useful, but WITHOUT ANY WARRANTY; without even the implied warranty
 * of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along
 * with Magestore POS Open Source. If not, see <https://www.gnu.org/licenses/>
 */ 
export default {
    CREATE_CREDITMEMO_PREPARE_TOTALS: '[CREDITMEMO] CREATE_CREDITMEMO_PREPARE_TOTALS',
    SALES_ORDER_CREDITEMEMO_INIT_TOTAL_COLLECTORS: '[CREDITMEMO] SALES_ORDER_CREDITEMEMO_INIT_TOTAL_COLLECTORS',
    SET_CREDITMEMO: '[CREDITMEMO] SET_CREDITMEMO',
    RESET_CREDITMEMO: '[CREDITMEMO] RESET_CREDITMEMO',
    CREATE_CREDITMEMO: '[CREDITMEMO] CREATE_CREDITMEMO',
    CREATE_CREDITMEMO_AFTER: '[CREDITMEMO] CREATE_CREDITMEMO_AFTER',
    SEND_EMAIL_CREDITMEMO: '[CREDITMEMO] SEND_EMAIL_CREDITMEMO',
    CREDITMEMO_CREATE_CUSTOMER: '[CREDITMEMO] CREDITMEMO_CREATE_CUSTOMER',
    CREDITMEMO_CREATE_CUSTOMER_RESULT: '[CREDITMEMO] CREDITMEMO_CREATE_CUSTOMER_RESULT',
    CREDITMEMO_PROCESS_PAYMENT: '[CREDITMEMO] TAKE_PAYMENT_PROCESS_PAYMENT',
    CREDITMEMO_PROCESS_SINGLE_PAYMENT_RESULT: '[CREDITMEMO] CREDITMEMO_PROCESS_SINGLE_PAYMENT_RESULT',
    CREDITMEMO_PROCESS_SINGLE_PAYMENT_ERROR: '[CREDITMEMO] CREDITMEMO_PROCESS_SINGLE_PAYMENT_ERROR',
    REFUND_OPERATION_REFUND_AFTER: '[CREDITMEMO] REFUND_OPERATION_REFUND_AFTER',
    CREDITMEMO_CREATE_ACTION_LOG_BEFORE: '[CREDITMEMO] CREDITMEMO_CREATE_ACTION_LOG_BEFORE',
}



// WEBPACK FOOTER //
// ./src/view/constant/order/CreditmemoConstant.js